import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from '../BaseComponent';
import { ToolsStoreState, ToolsStore, ExtraPopup } from '../../stores/ToolsStore';
import { GroundType, ProjectSettingsStore } from '../../stores/ProjectSettingsStore';
import { SceneStore } from '../../stores/SceneStore';
import { ToolsActions } from '../../actions/ToolsActions';
import { AppHelper } from '../../utils/AppHelper';
import { SelectBoxOption, SelectBoxStore } from '../../stores/SelectBoxStore';
import { ProjectSettingsActions } from '../../actions/ProjectSettingsActions';
import { UIHelper } from '../../utils/UIHelper';
import { VisibilityActions } from '../../actions/VisibilityActions';
import { PopupMenu } from '../../constants/Enums';
import { AppConfigurationStore } from '../../stores/AppConfigurationStore';
import { GlobalHelper } from '../../utils/GlobalHelper';
import { DialogActions } from '../../actions/DialogActions';
import { ClickButton } from '../ClickButton';
import { SceneActions } from '../../actions/SceneActions';
import { BasePopupMenuOption } from './BasePopupMenuOption';
import { BasePopupMenuHeader } from './BasePopupMenuHeader';

import core = egr.wcf.core;
import room = egr.wcf.room;
import { ArButton } from '../ar/ARButton';
import { ViewSettingsActions } from '../../actions/ViewSettingsActions';
import { ArticleActions } from '../../actions/ArticleActions';

interface SmartExtraPopupProps extends React.Props<SmartExtraPopup> {
    sidebarOrientation: string;
}

interface SmartExtraPopupState extends ToolsStoreState {
    canRedo: boolean;
    canUndo: boolean;
    articleSelected: boolean;
    groundType: GroundType | 'floorplan';
}

export class SmartExtraPopup extends BaseComponent<SmartExtraPopupProps, SmartExtraPopupState> {
    public componentWillMount(): void {
        this.addStoreListener(ProjectSettingsStore, this.onChange);
        this.addStoreListener(SceneStore, this.onChange);
        this.addStoreListener(ToolsStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null {
        if (!this.state.smartPopup) {
            return null;
        }
        switch (this.state.smartPopup) {
            case ExtraPopup.CAMERA:
                return (
                    <div className="smart-extra-underlay" onClick={ToolsActions.hideSmartExtra} key="smart-camera">
                        <div
                            className={
                                'smart-extra-popup with-popupflag top-arrow align-right' + (this.props.sidebarOrientation === 'right' ? ' on-right-side' : '')
                            }
                            onClick={UIHelper.stopEvent}
                        >
                            <div className="smart-extra-buttons">
                                <BasePopupMenuHeader label={t('View')} callback={ToolsActions.showSmartExtra} className="egr-select-option-header-back"/>
                                <ClickButton
                                    className="smart-button ortho-cam"
                                    key="smart-ortho"
                                    active={this.state.camera === core.view.CameraMode.Orthographic}
                                    callback={() => {ToolsActions.setCamera(core.view.CameraMode.Orthographic); }}
                                >
                                    <div className="smart-button-label">{t('Orthographic')}</div>
                                </ClickButton>
                                <ClickButton
                                    className="smart-button front-cam"
                                    key="smart-front"
                                    active={this.state.camera === core.view.CameraMode.Front}
                                    callback={() => {ToolsActions.setCamera(core.view.CameraMode.Front); }}
                                >
                                    <div className="smart-button-label">{t('Front')}</div>
                                </ClickButton>
                                <ClickButton
                                    className="smart-button left-cam"
                                    key="smart-left"
                                    active={this.state.camera === core.view.CameraMode.Left}
                                    callback={() => {ToolsActions.setCamera(core.view.CameraMode.Left); }}
                                >
                                    <div className="smart-button-label">{t('Left')}</div>
                                </ClickButton>
                                <ClickButton
                                    className="smart-button right-cam"
                                    key="smart-right"
                                    active={this.state.camera === core.view.CameraMode.Right}
                                    callback={() => {ToolsActions.setCamera(core.view.CameraMode.Right); }}
                                >
                                    <div className="smart-button-label">{t('Right')}</div>
                                </ClickButton>
                                <ClickButton
                                    className="smart-button back-cam"
                                    key="smart-back"
                                    active={this.state.camera === core.view.CameraMode.Back}
                                    callback={() => {ToolsActions.setCamera(core.view.CameraMode.Back); }}
                                >
                                    <div className="smart-button-label">{t('Rear')}</div>
                                </ClickButton>
                                <ClickButton
                                    className="smart-button bottom-cam"
                                    key="smart-bottom"
                                    active={this.state.camera === core.view.CameraMode.Bottom}
                                    callback={() => {ToolsActions.setCamera(core.view.CameraMode.Bottom); }}
                                >
                                    <div className="smart-button-label">{t('Bottom')}</div>
                                </ClickButton>
                                {SelectBoxStore.getWallOptions().map((wallOption: any, index: number) => {
                                    return <BasePopupMenuOption key={index} {...wallOption} first={false} active={false} optionClick={() => { return; }}/>;
                                })}
                            </div>
                        </div>
                    </div>
                );
            case ExtraPopup.FLOORPLAN:
                return (
                    <div className="smart-extra-underlay" onClick={ToolsActions.hideSmartExtra} key="smart-floorplan">
                        <div
                            className={
                                'smart-extra-popup with-popupflag top-arrow align-right' + (this.props.sidebarOrientation === 'right' ? ' on-right-side' : '')
                            }
                            onClick={UIHelper.stopEvent}
                        >
                            <div className="smart-extra-buttons">
                                <BasePopupMenuHeader label={t('Workspace')} callback={ToolsActions.showSmartExtra} className="egr-select-option-header-back"/>
                                {this.groundOptions().map(this.getGroundOption)}
                            </div>
                        </div>
                    </div>
                );
            case ExtraPopup.TOOLS:
                return (
                    <div className="smart-extra-underlay" onClick={ToolsActions.hideSmartExtra} key="smart-floorplan">
                        <div
                            className={
                                'smart-extra-popup with-popupflag top-arrow align-right' + (this.props.sidebarOrientation === 'right' ? ' on-right-side' : '')
                            }
                            onClick={UIHelper.stopEvent}
                        >
                            <div className="smart-extra-buttons">
                                <BasePopupMenuHeader label={t('Tools')} callback={ToolsActions.showSmartExtra} className="egr-select-option-header-back" />
                                <ClickButton
                                    className="smart-button tools-dimension-line"
                                    key="smart-tools-dimension-line"
                                    callback={
                                        // tslint:disable-next-line:jsx-no-lambda
                                        () => {
                                            ToolsActions.hideSmartExtra();
                                            const tool: room.tool.Measure = new room.tool.Measure(GlobalHelper.roomManager);
                                            tool.eventStopped.addListener(() => {
                                                ViewSettingsActions.setDragMode(false);
                                                ArticleActions.invalidateArticleList();
                                            });
                                            GlobalHelper.coreApp.tools.startTool(tool);
                                            GlobalHelper.focusCanvas();
                                            ViewSettingsActions.setDragMode(true);
                                        }
                                    }
                                >
                                    <div className="smart-button-label">{t('Dimension line')}</div>
                                </ClickButton>
                                <ClickButton
                                    className="smart-button tools-text"
                                    key="smart-tools-text"
                                    callback={
                                        // tslint:disable-next-line:jsx-no-lambda
                                        () => {
                                            ToolsActions.hideSmartExtra();
                                            GlobalHelper.roomManager.insertRoomElement('Text');
                                        }
                                    }
                                >
                                    <div className="smart-button-label">{t('Text')}</div>
                                </ClickButton>
                            </div>
                        </div>
                    </div>
                );
            default:
                return (
                    <div className="smart-extra-underlay" onClick={ToolsActions.hideSmartExtra} key="smart-default">
                        <div
                            className={
                                'smart-extra-popup with-popupflag top-arrow align-right' +
                                (this.props.sidebarOrientation === 'right' ? ' on-right-side' : '')
                            }
                            onClick={UIHelper.stopEvent}
                        ><div className="smart-extra-buttons">
                            <ArButton/>
                            <ClickButton
                                className="smart-button undo-button"
                                key="smart-undo"
                                disabled={!this.state.canUndo}
                                callback={() => {SceneActions.undo(); ToolsActions.hideSmartExtra(); }}
                            >
                                <div className="smart-button-label">{t('Undo')}</div>
                            </ClickButton>
                            <ClickButton
                                className="smart-button redo-button"
                                key="smart-redo"
                                disabled={!this.state.canRedo}
                                callback={() => {SceneActions.redo(); ToolsActions.hideSmartExtra(); }}
                            >
                                <div className="smart-button-label">{t('Redo')}</div>
                            </ClickButton>
                            {AppConfigurationStore.getState().floorplanAvailable ? (
                                <ClickButton
                                    className="smart-button workspace-button"
                                    key="smart-workspace"
                                    callback={() => { VisibilityActions.setPopupMenu(PopupMenu.ENVIRONMENT_FLOORPLAN_SETUP); ToolsActions.hideSmartExtra(); }}
                                >
                                    <div className="smart-button-label">{t('Workspace')}</div>
                                </ClickButton>
                            ) : null}
                            <ClickButton
                                className="smart-button multiselect-button"
                                key="smart-multiselect"
                                active={this.state.multiSelect}
                                callback={this.multiSelect}
                            >
                                <div className="smart-button-label">{t('Multi Selection')}</div>
                            </ClickButton>
                            <ClickButton
                                className="smart-button lasso-button"
                                key="smart-lasso"
                                callback={this.rectangleSelect}
                                active={this.state.rectangleSelect}
                            >
                                <div className="smart-button-label">{t('Rectangular Selection')}</div>
                            </ClickButton>
                            <ClickButton
                                className="smart-button clone-button"
                                key="smart-clone"
                                disabled={!this.state.articleSelected}
                                callback={() => {SceneActions.cloneSelectedElements(); ToolsActions.hideSmartExtra(); }}
                            >
                                <div className="smart-button-label">{t('Clone')}</div>
                            </ClickButton>
                            {AppConfigurationStore.getState().inApp ? (
                                <ClickButton
                                    className="smart-button share-image-button"
                                    key="smart-share-image"
                                    active={this.state.sendImage === 'send'}
                                    callback={this.shareImage}
                                >
                                <div className="smart-button-label">{t('Share Image')}</div>
                                </ClickButton>
                            ) : null}
                            {AppConfigurationStore.getState().inApp ? (
                                <ClickButton
                                    className="smart-button snapshot-button"
                                    key="smart-snapshot"
                                    active={this.state.sendImage === 'snapshot'}
                                    callback={this.makeSnapshot}
                                >
                                    <div className="smart-button-label">{t('Snapshot')}</div>
                                </ClickButton>
                            ) : null}
                                <ClickButton
                                    className="smart-button views-button tab-button"
                                    key="smart-views"
                                    callback={ToolsActions.showCameraSelection}
                                >
                                    <div className="smart-button-label">{t('View')}</div>
                                </ClickButton>
                                <ClickButton
                                    className="smart-button tools-button tab-button"
                                    key="smart-tools"
                                    callback={ToolsActions.showToolsMenu}
                                >
                                    <div className="smart-button-label">{t('Tools')}</div>
                                </ClickButton>
                            </div>
                        </div>
                    </div>
                );
        }
    }

    protected onChange = (): void => {
        this.setState(jQuery.extend(
            {},
            ToolsStore.getState(),
            {canUndo: SceneStore.getState().canUndo},
            {canRedo: SceneStore.getState().canRedo},
            {articleSelected: SceneStore.articleSelected()},
            {groundType: ProjectSettingsStore.getFloorPlanVisibility() ? 'floorplan' : (ProjectSettingsStore.getState().groundType || 'solid')}
        ));
    };

    protected shareImage = (): void => {
        ToolsActions.sendImage('send');
        AppHelper.shareScreenshot(false).then(() => {
            ToolsActions.sendImage(null);
            ToolsActions.hideSmartExtra();
        });
    };

    protected makeSnapshot = (): void => {
        ToolsActions.sendImage('snapshot');
        AppHelper.shareScreenshot(true).then(() => {
            ToolsActions.sendImage(null);
            ToolsActions.hideSmartExtra();
        });
    };

    protected rectangleSelect = (): void => {
        ToolsActions.startRectangleSelect();
        ToolsActions.hideSmartExtra();
    };

    protected multiSelect = (): void => {
        if (this.state.multiSelect) {
            ToolsActions.setMultiSelect(false);
            ToolsActions.hideSmartExtra();
        } else {
            ToolsActions.setMultiSelect(true);
            ToolsActions.hideSmartExtra();
        }
    };

    protected getGroundOption = (pOption: SelectBoxOption, index: number): JSX.Element => {
        return (
            <BasePopupMenuOption key={index} {...pOption} active={this.state.groundType === pOption.value}/>
        );
    };

    protected groundOptions = (): Array<SelectBoxOption> => {
        const result: Array<SelectBoxOption> = [
            {
                name: t('Invisible', {context: 'button-label (first letter upper case)'}),
                value: 'nofloor',
                className: 'egr-select-option-noicon',
                callback: () => { ProjectSettingsActions.setGroundType('nofloor'); }
            },
            {
                name: t('Color'),
                value: 'solid',
                className: 'egr-select-option-has-extrabutton',
                callback: () => { ProjectSettingsActions.setGroundType('solid'); },
                extraButtons: [(
                    <div
                        key="sprite-icon-pen"
                        className="egr-select-extrabutton sprite-icon-pen"
                        onClick={(event) => {
                            UIHelper.stopEvent(event);
                            ProjectSettingsActions.setGroundType('solid');
                            VisibilityActions.setPopupMenu(PopupMenu.SOLIDFLOOR_SETUP);
                            ToolsActions.hideSmartExtra();
                        }}
                    />
                )]
            },
        ];
        if (AppConfigurationStore.getState().floorplanAvailable) {
            if (GlobalHelper.floorPlan == null || !GlobalHelper.floorPlan.hasTexture()) {
                result.push({
                    name: t('Floor Plan'),
                    value: 'floorplan',
                    className: 'egr-select-option-has-extrabutton',
                    callback: () => {
                        DialogActions.triggerFloorPlanUpload();
                        ToolsActions.hideSmartExtra();
                    },
                    extraButtons: [<div key="sprite-icon-upload" className="egr-select-extrabutton sprite-icon-upload"/>]
                });
            } else {
                result.push({
                    name: t('Floor Plan'),
                    value: 'floorplan',
                    className: 'egr-select-option-has-extrabutton',
                    callback: () => {
                        ProjectSettingsActions.showFloorPlan();
                    },
                    extraButtons: [(
                        <div
                            key="sprite-icon-pen"
                            className="egr-select-extrabutton sprite-icon-pen"
                            onClick={(event) => {
                                UIHelper.stopEvent(event);
                                ProjectSettingsActions.showFloorPlan();
                                VisibilityActions.setPopupMenu(PopupMenu.FLOORPLAN_SETUP);
                                ToolsActions.hideSmartExtra();
                            }}
                        />
                    )]
                });
            }
        }
        return result;
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/popupmenu/SmartExtraPopup.tsx